export const image_height = 150;
export const image_width = 150;

export const picture_height = 250;
export const picture_width = 250;